import { DomainNotificationTemplateProviderAction, DomainNotificationTemplateProviderState } from './types'

export function domainNotificationTemplateProviderReducer(
    state: DomainNotificationTemplateProviderState,
    action: DomainNotificationTemplateProviderAction,
): DomainNotificationTemplateProviderState {
    const next = { ...state }

    switch (action.type) {
        case 'loading:set': {
            next.loading = action.loading
            break
        }

        case 'notifications:set': {
            next.template = action.template
            next.notifications = action.notifications
            break
        }
    }

    return next
}
